// Beløp i hele kroner: «kr 1 250», negative som «−kr 250» (vanlig minustegn).
export function formatKr(n) {
  const v = Number(n ?? 0);
  return `${v < 0 ? '−' : ''}kr ${Math.abs(v).toLocaleString('nb-NO')}`;
}
